export const learningFocus = [
  {
    id: "history-statecraft",
    discipline: "History & Ancient Statecraft",
    status: "Active Study",
    description:
      "Deep examination of ancient and modern Indian history, civilizational trajectories, administrative institutions, and classical treatises on governance (including Kautilya's Arthashastra).",
    relatedBookSlugs: ["arthashastra", "the-lessons-of-history"],
    relatedWritingSlug: "kautilya-and-institutional-incentives",
    tags: ["Ancient India", "Modern History", "Statecraft", "Administration"]
  },
  {
    id: "polity-governance",
    discipline: "Constitutional Polity & Governance",
    status: "Structured Preparation",
    description:
      "Systematic study of the Indian Constitution, parliamentary frameworks, federal relations, public administration oversight, and institutional checks and balances (UPSC / SSC curriculum foundations).",
    relatedBookSlugs: ["the-prince"],
    tags: ["Indian Constitution", "Public Administration", "Governance", "Institutions"]
  },
  {
    id: "political-economy",
    discipline: "Political Economy & Development",
    status: "Ongoing Inquiry",
    description:
      "Understanding macroeconomic principles, fiscal policies, agrarian systems, industrial transformations, and institutional incentives that govern societal prosperity and resource distribution.",
    relatedBookSlugs: ["the-lessons-of-history"],
    tags: ["Macroeconomics", "Fiscal Policy", "Development", "Public Policy"]
  },
  {
    id: "algorithms-systems",
    discipline: "Algorithmic Problem Solving & Systems",
    status: "Continuous Mastery",
    description:
      "Maintaining algorithmic problem-solving sharpness on Codeforces (Candidate Master · max rating 2013) while studying core systems principles: memory hierarchy, POSIX APIs, concurrency, and interpreter design.",
    relatedBookSlugs: ["structure-and-interpretation-of-computer-programs", "the-pragmatic-programmer", "introduction-to-algorithms"],
    relatedWritingSlug: "algorithmic-intuition-in-competitive-programming",
    relatedProjectSlug: "c-terminal-shell",
    tags: ["Competitive Programming", "C++", "POSIX Systems", "Algorithms"]
  },
  {
    id: "biology-curiosity",
    discipline: "Biology & Evolutionary Genetics Curiosity",
    status: "Active Exploration // In Progress",
    description:
      "Curious exploration into evolutionary biology, molecular genetics, cellular automata, natural selection mechanics, and biological information processing systems.",
    relatedBookSlugs: [],
    tags: ["Evolutionary Biology", "Genetics", "Cellular Automata", "Natural Systems"]
  }
];

export const knowledgeMapNodes = [
  {
    id: "history",
    name: "History & Macro-Patterns",
    description: "Civilizational cycles, institutional rise and decay, lessons of statecraft.",
    connections: ["polity", "philosophy"]
  },
  {
    id: "polity",
    name: "Polity, Law & Governance",
    description: "Constitutional mechanics, administrative incentives, public governance.",
    connections: ["history", "economics"]
  },
  {
    id: "economics",
    name: "Political Economy",
    description: "Resource allocation, fiscal policy, agrarian and industrial transitions.",
    connections: ["polity", "technology"]
  },
  {
    id: "technology",
    name: "Systems & Technology",
    description: "Software architecture, low-level tooling, deterministic computing.",
    connections: ["economics", "algorithms"]
  },
  {
    id: "algorithms",
    name: "Algorithms & Discrete Math",
    description: "Pattern recognition, invariant reduction, computational problem solving.",
    connections: ["technology", "philosophy"]
  },
  {
    id: "philosophy",
    name: "Philosophy & Literature",
    description: "Moral inquiry, Stoic resilience, human agency, and epistemology.",
    connections: ["history", "algorithms"]
  }
];

export const learningMethods = [
  {
    code: "01",
    step: "READ",
    title: "Primary Texts & Canonical Literature",
    description: "Engaging directly with foundational treatises, textbooks, and primary historical documents rather than relying solely on superficial summaries."
  },
  {
    code: "02",
    step: "STUDY",
    title: "Structured Curriculum & Invariant Reduction",
    description: "Disciplined daily study across core domains—breaking complex administrative and algorithmic topics down to their underlying invariants."
  },
  {
    code: "03",
    step: "BUILD",
    title: "Concrete Engineering Implementations",
    description: "Validating theoretical knowledge by implementing working systems: command-line shells, LaTeX handbooks, and deterministic web tools."
  },
  {
    code: "04",
    step: "WRITE",
    title: "Synthesis & Long-Form Articulation",
    description: "Clarifying understanding through writing—drafting essays, research notes, and book manuscript chapters to test depth of thought."
  }
];
